import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import * as storeTypes from '../store/types'
import Application from '@/components/application/Application'
import Login from '@/components/login/Login'
import EANCode from '@/components/application/EANCode/EANCode'
import AddEAN from '@/components/application/EANCode/AddEAN'
import EditEAN from '@/components/application/EANCode/EditEAN'
import UserManagement from '@/components/application/userManagement/UserManagement'
import AddUser from '@/components/application/UserManagement/AddUser'
import EditUser from '@/components/application/UserManagement/EditUser'
import ResetPassword from '@/components/application/UserManagement/ResetPassword'
import QRCCode from '@/components/application/QRC/QRCCode'
import QRCHistory from '@/components/application/QRC/QRCHistory'
import NoAuth from '@/components/common/401'
import NotFound from '@/components/common/404'
import Cashback from '@/components/application/Cashback/Cashback'
import AddCashback from '@/components/application/Cashback/AddCashback'
import EditCashback from '@/components/application/Cashback/EditCashback'
import CMUserInfo from '@/components/application/CMUserInfo/CMUserInfo'
import Delivery from '@/components/application/Delivery/Delivery'
import BoxScan from '@/components/application/BoxScan/BoxScan'
import ScanInfo from '@/components/application/BoxScan/ScanInfo'
import CodeScanningInformation from '@/components/application/CodeScanningInformation/CodeScanningInformation'
import AddCodeScanningInformation from '@/components/application/CodeScanningInformation/AddCodeScanningInformation'
import EditCodeScanningInformation from '@/components/application/CodeScanningInformation/EditCodeScanningInformation'
import Report from '@/components/application/Report/Report'
import ProductReturn from '@/components/application/ProductReturn/ProductReturn'
import ReturnScan from '@/components/application/ProductReturn/ReturnScan'
import {Message} from 'element-ui'


Vue.use(Router)

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/401',
      name: 'Error401',
      component: NoAuth
    },
    {
      path: '/404',
      name: 'Error404',
      component: NotFound
    },
    {
      path: '/',
      name: "App",
      component: Application,
      meta: { requireAuth: true },
      children: [
        {
          path: 'EANCode',
          name: 'EANCode',
          component: EANCode,
          meta: { requireAuth: true }
        },
        {
          path: 'addEAN',
          name: 'AddEAN',
          component: AddEAN,
          meta: { requireAuth: true }
        },
        {
          path: 'editEAN/:EANId',
          name: 'EditEAN',
          component: EditEAN,
          meta: { requireAuth: true }
        },
        {
          path: 'userManagement',
          name: 'UserManagement',
          component: UserManagement,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'userManagement/add',
          name: 'AddUser',
          component: AddUser,
          meta: { requireAuth: true }
        },
        {
          path: 'userManagement/:userId',
          name: 'EditUser',
          component: EditUser,
          meta: { requireAuth: true }
        },
        {
          path: 'userManagement/resetPassword/:userId',
          name: 'ResetPassword',
          component: ResetPassword,
          meta: { requireAuth: true }
        },
        {
          path: 'QRCCode',
          name: 'QRCCode',
          component: QRCCode,
          meta: { requireAuth: true }
        },
        {
          path: 'QRCCode/history',
          name: 'QRCHistory',
          component: QRCHistory,
          meta: { requireAuth: true }
        },
        {
          path: 'Cashback',
          name: 'Cashback',
          component: Cashback,
          meta: { requireAuth: true }
        },
        {
          path: 'AddCashback',
          name: 'AddCashback',
          component: Cashback,
          meta: { requireAuth: true }
        },
        {
          path: 'EditCashback',
          name: 'EditCashback',
          component: EditCashback,
          meta: { requireAuth: true }
        },
        {
          path: 'CMUser',
          name: 'CMUser',
          component: CMUserInfo,
          meta: { requireAuth: true }
        },
        {
          path: 'delivery',
          name: 'Delivery',
          component: Delivery,
          meta: { requireAuth: true }
        },
        {
          path: 'delivery/boxscan',
          name: 'BoxScan',
          component: BoxScan,
          meta: { requireAuth: true }
        },
        {
          path: 'delivery/boxscan/scaninfo',
          name: 'ScanInfo',
          component: ScanInfo,
          meta: { requireAuth: true }
        },
        {
          path: 'CodeScanningInformation',
          name: 'CodeScanningInformation',
          component: CodeScanningInformation,
          meta: { requireAuth: true }
        },
        {
          path: 'addCodeScanningInformation',
          name: 'AddCodeScanningInformation',
          component: AddCodeScanningInformation,
          meta: { requireAuth: true }
        },
        {
          path: 'editCodeScanningInformation',
          name: 'EditCodeScanningInformation',
          component: EditCodeScanningInformation,
          meta: { requireAuth: true }
        },
        {
          path: 'report',
          name: 'Report',
          component: Report,
          meta: { requireAuth: true }
        },
        {
          path: 'product/return',
          name: 'ProductReturn',
          component: ProductReturn,
          meta: { requireAuth: true }
        },
        {
          path: 'product/return/scan',
          name: 'ReturnScan',
          component: ReturnScan,
          meta: { requireAuth: true }
        },
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

import menus from '../Infrustructure/menu'
let setMenuIndex = function (routeName) {
  let menu = menus.find(m => m.routeName === routeName);
  if (menu) {
    store.commit(storeTypes.MENUINDEX, routeName);
  }
}

let closeMessage = function(){
  Message.closeAll();
}

router.beforeEach((to, from, next) => {
  closeMessage();
  setMenuIndex(to.name);

  if (to.meta.requireAuth) {
    //已登录
    if (store.getters.token) {
      //如果是根路径'/'跳转到第一个菜单
      if (to.fullPath === '/') {
        let menus = store.getters.menus;
        let routeName = menus && menus.length && menus[0].routeName;
        if (routeName) {
          next({
            name: routeName || 'App'
          })
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      //未登录
      var route = { name: 'Login' }
      if (to.fullPath !== '/') {
        route.query = {
          redirect: to.fullPath
        }
      }
      next(route);
    }
  } else {
    next();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js